module.exports = __webpack_public_path__ + "ga.f2442ae0.svg";